module.exports = __webpack_public_path__ + "img/logo-papelia.85f381e9.png";